import { AxiosResponse } from "axios";

import {
  ICustomMedication,
  ISaveCustomMedicationRequest,
} from "../../@types/admin/AdminMedication";
import { api } from "../api";

const base = (hospitalGroupId: number) =>
  `/Retool/Hospitals/${hospitalGroupId}/CustomMedications`;

/**
 * Custom medications admin page (EN-5240): one hospital's study medications
 * and vitamins. Hospital-scoped routes, under `medications:access`.
 */
export const customMedicationsService = {
  /**
   * Inactive ones are included: deactivation is reversible and a name stays
   * taken while its item exists, so the operator needs to see them.
   */
  async getCustomMedications(
    hospitalGroupId: number
  ): Promise<AxiosResponse<ICustomMedication[]>> {
    return api.get<ICustomMedication[]>(base(hospitalGroupId), {
      params: { includeInactive: true },
    });
  },

  async createCustomMedication(
    hospitalGroupId: number,
    request: ISaveCustomMedicationRequest
  ): Promise<AxiosResponse<ICustomMedication>> {
    return api.post<ICustomMedication>(base(hospitalGroupId), request);
  },

  async updateCustomMedication(
    hospitalGroupId: number,
    id: string,
    request: ISaveCustomMedicationRequest
  ): Promise<AxiosResponse<ICustomMedication>> {
    return api.put<ICustomMedication>(
      `${base(hospitalGroupId)}/${id}`,
      request
    );
  },

  /** Stops offering it to patients. Never deleted — patient records point at it. */
  async deactivateCustomMedication(
    hospitalGroupId: number,
    id: string
  ): Promise<AxiosResponse<unknown>> {
    return api.post(`${base(hospitalGroupId)}/${id}/Deactivate`);
  },

  async reactivateCustomMedication(
    hospitalGroupId: number,
    id: string
  ): Promise<AxiosResponse<ICustomMedication>> {
    return api.post<ICustomMedication>(
      `${base(hospitalGroupId)}/${id}/Reactivate`
    );
  },
};
